// Canonical internal/partner role set. Lives in the `types` layer so both the
// `config` (nav) and `routes` (guards) layers can share one source of truth —
// `config` may not import from `features`, so the union cannot live in auth.
// The auth zod schema re-uses `ROLES` for `userSchema.role`.
// These tokens mirror the backend `AdminRole` enum exactly — a mismatch silently breaks access
// control, so never diverge. `operational_associate` (customer support + logistics merged into
// one role) and `field_installer` replaced `customer_support_logistics`/`field_technician` per
// the BA decision recorded on story 101637, 2026-07-24.
export const ROLES = [
  'super_admin',
  'admin',
  'operational_associate',
  'field_installer',
  'dealer',
] as const;

export type Role = (typeof ROLES)[number];

/**
 * Every role but `dealer` — the Greenway staff roles (CONTEXT.md "User (internal)"). Guards the
 * admin routes that carry no narrower role list of their own, so a dealer who types one of their
 * URLs is refused rather than shown an admin page whose every request 403s (ADO 120818 §G).
 */
export const INTERNAL_ROLES: Role[] = ROLES.filter((r) => r !== 'dealer');
